.themeSwitchWrapper {
  position: relative;
  width: 44px;
  height: 24px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  transition: background 0.3s;
  background: #CBD1E3;
}
.themeSwitchWrapper.dark {
  background: #0C3451;
}
.themeSwitchWrapper.light {
  background: #CBD1E3;
}
.thumb {
  position: absolute;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 2px 8px 0 rgba(0,0,0,0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
